import React, { useState } from 'react';
import styled from 'astroturf/react';

type Props = {
  text: string;
  characters: number;
  collapsible?: boolean;
  className?: string;
};

const Text = styled.span`
  margin-left: 2px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const TruncateText: React.FC<Props> = ({
  text,
  characters,
  collapsible = false,
  className,
}) => {
  const [truncate, setTruncate] = useState(true);

  return (
    <div className={className}>
      <div>
        {text.slice(0, truncate ? characters : undefined)}
        {text.length > characters && (collapsible || truncate) && (
          <Text onClick={() => setTruncate(!truncate)}>
            {truncate ? '... more ▾' : 'less'}
          </Text>
        )}
      </div>
    </div>
  );
};
